/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
import { UserData } from "ember-wiser/-private/types";
export default class CtcaeCustomBaseEditionFormDigestiveRecovery extends Component {}